import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  FormLayout,
  TextField,
  Checkbox,
  Card,
  Button,
  Text,
  Image,
  TextContainer,
  Loading,
  Select,
  Modal,
  ButtonGroup,
  Toast,
  Icon,
  Autocomplete,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import {
  LanguageMinor,
  MobileVerticalDotsMajor,
  ColorsMajor,
} from "@shopify/polaris-icons";
import emptyListImage from "../Assets/Images/emptyList.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { AddMajor, SearchMinor } from "@shopify/polaris-icons";
import Instruction from "./Instruction";
import DraggableListItemShopifyProduct from "./DraggableListItemShopifyProduct";
import { accessEditSections } from "../Helpers";
import AsyncSelect from "react-select/async";
import instructionImg from "../Assets/Images/instruction-help.svg";

const ListShopifyProducts = (props) => {
  const [data, setData] = useState([]);
  const [isSorting, setIsSorting] = useState(false);
  const loadingMarkup = isSorting ? <Loading /> : null;
  let object = JSON.parse(props.object);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(true);
  const emtyState = isListEmpty && (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  );
  const [result, setResult] = useState([]);

  const reorder = (list, startIndex, endIndex) => {
    const result2 = Array.from(list);
    const [removed] = result2.splice(startIndex, 1);
    result2.splice(endIndex, 0, removed);
    return result2;
  };
  const equalsCheck = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };
  const onDragEnd = (result2) => {
    if (!result2.destination) {
      return;
    }
    const reorderedItems = reorder(
      result,
      result2.source.index,
      result2.destination.index
    );
    if (
      !equalsCheck(
        reorderedItems.map((a) => a.id),
        result.map((a) => a.id)
      )
    ) {
      setIsSorting(true);
      setResult(reorderedItems);
      const bodyObj = { ids: reorderedItems.map((item) => item.id) };
      axios
        .post(`/sections/${props.sectionId}/shopify_product/sort`, bodyObj)
        .then((res) => {
          // setToastMessage("Sections order has been successfully updated");
          //toggleActiveToast();
          setIsSorting(false);
          //props.handleRefreshSections();
        })
        .catch((err) => console.log(""));
    }
  };

  const [item, setItem] = useState({
    title: "",
    titleTranslated: "",
    active: "",
    subtitle: "",
    subtitleTranslated: "",
    items: [],
  });
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
    setItem({
      ...item,
      titleTranslated:
        object?.title && object?.title[value] ? object?.title[value] : "",
      subtitleTranslated:
        object?.subtitle && object?.subtitle[value]
          ? object?.subtitle[value]
          : "",
    });
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };

  const [activeAddItem, setActiveAddItem] = useState(false);
  const handleCloseModalAddItem = () => {
    setActiveAddItem(!activeAddItem);
  };
  const handleAddItem = () => {
    setActiveAddItem(!activeAddItem);
  };
  const handleSubmit = () => {
    setIsSaving(true);
    axios

      .post(`sections/${props.sectionId}/shopify_product`, {
        is_active: 1,
        product_handle: shopifyProduct.value,
        product_id: shopifyProduct.id,
      })
      .then((result) => {
        setToastContent("Item added successfully");
        toggleActive();
        setActiveAddItem(false);
        setIsSaving(false);
        props.handleRefreshSections();
      })
      .catch((err) => console.log(err));
  };

  const [activeEditItem, setActiveEditItem] = useState(false);
  const handleCloseModalEditItem = () => {
    setActiveEditItem(false);
  };
  let refClickedItem = useRef(null);
  const handleEditItem = (param) => {
    console.log(param?.product_handle);
    refClickedItem.current = param;
    setShopifyProduct({
      label:
        param?.product_details && param?.product_details?.title
          ? param?.product_details?.title
          : "",
      value: param?.product_handle ? param?.product_handle : "",
    });
    setActiveEditItem(true);
  };
  const handleSubmitEdit = () => {
    setIsSaving(true);
    axios
      .patch(
        `sections/${props.sectionId}/shopify_product/${refClickedItem.current.id}`,
        {
          is_active: 1,
          product_handle: shopifyProduct.value,
          product_id: shopifyProduct.id,
        }
      )
      .then((result) => {
        //toggleActive();
        setIsSaving(false);
        setActiveEditItem(false);
        props.handleRefreshSections();
      })
      .catch((err) => console.log(err));
  };
  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    object = JSON.parse(props.object);
    !object.details?.list?.length
      ? setIsListEmpty(true)
      : setIsListEmpty(false);

    object?.details?.list?.length
      ? setResult(object?.details?.list)
      : setResult("");
  }, [props]);
  useEffect(() => {
    const handler = (e) => {
      if (
        e.target.closest(
          ".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root"
        ) !== null
      ) {
        e.stopImmediatePropagation();
      }
    };
    document.addEventListener("focusin", handler);
    return () => document.removeEventListener("focusin", handler);
  }, []);
  useEffect(() => {
    object = JSON.parse(props.object);

    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.title && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            position: object?.details?.image_position
              ? object?.details?.image_position
              : "",
            active: object?.details?.is_active ? true : false,
            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
          };
        })
    );
  }, [props.object]);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This item has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`sections/${props.sectionId}/shopify_product/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        props.handleRefreshSections();
      })
      .catch((err) => console.log(err));
  };

  const [shopifyProduct, setShopifyProduct] = useState("");
  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: item.handle,
                id: item.id,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: item.handle,
              id: item.id,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const handleSelectChangeShopifyProduct = (value) => {
    setShopifyProduct(value);
  };

  return (
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}
      {loadingMarkup}
      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageMinor : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>

      <table>
        <tbody>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  onChange={handleChangeTitleTranslated}
                />
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  onChange={handleChangeSubtitleTranslated}
                />
              </td>
            )}
          </tr>
        </tbody>
      </table>

      <Card>
        <div className="mt-5 mb-3">
          <Button
            outline
            fullWidth
            onClick={handleAddItem}
            icon={AddMajor}
            disabled={!accessEditSections()}
          >
            Add Item
          </Button>
        </div>
        {result && result.length && (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={"droppable"}>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                >
                  {result.map((element, idx) => (
                    <Draggable
                      key={element.id}
                      draggableId={String(element.id)}
                      index={idx}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          {/* <ButtonGroup>
                            <Button plain onClick={() => handleEditItem(item)}>
                              Edit
                            </Button>
                            <Button
                              plain
                              destructive
                              onClick={() => handleDelete(item.id)}
                            >
                              Remove
                            </Button>
                          </ButtonGroup> */}
                          <DraggableListItemShopifyProduct
                            title={
                              element.product_details &&
                              element.product_details.title
                                ? element.product_details.title
                                : ""
                            }
                            handleEditItem={() => handleEditItem(element)}
                            handleDelete={handleDelete}
                            id={element.id}
                            element={element}
                          />
                          {/* {element.id} */}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}

        {emtyState}
      </Card>
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button primary onClick={handleSave} loading={props.isSaving}>
            Save
          </Button>
        </div>
      </FormLayout.Group>
      <Modal
        large
        open={activeAddItem}
        onClose={handleCloseModalAddItem}
        title="Add Item"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleCloseModalAddItem,
          },
        ]}
      >
        <Modal.Section>
          <AsyncSelect
            cacheOptions
            defaultOptions={firstTimeLoadedProductsOptions}
            loadOptions={loadOptionsProducts}
            onChange={handleSelectChangeShopifyProduct}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={shopifyProduct}
          />

          {/* <Autocomplete
            options={optionsProducts}
            selected={selectedOptionsProducts}
            onSelect={updateSelectionProduct}
            textField={textFieldProduct}
          /> */}
        </Modal.Section>
      </Modal>
      <Modal
        large
        open={activeEditItem}
        onClose={handleCloseModalEditItem}
        title="Edit Item"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmitEdit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleCloseModalEditItem,
          },
        ]}
      >
        <Modal.Section>
          <AsyncSelect
            cacheOptions
            defaultOptions={firstTimeLoadedProductsOptions}
            loadOptions={loadOptionsProducts}
            onChange={handleSelectChangeShopifyProduct}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={shopifyProduct}
          />
        </Modal.Section>
      </Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this item?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </FormLayout>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));
    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );
    data.forEach((selected, index) =>
      form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
    );
    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    form_data.append("_method", "PATCH");
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default ListShopifyProducts;
